import { InjectionToken } from '@angular/core';
import { DirectusLanguageCode, TranslatedField } from '@planone/schuecoportal/util-model';

export interface DirectusEnvironment {
  url: string;
}
export type Locale = 'de' | 'en';
export const DirectusLocaleMapping: Record<Locale, DirectusLanguageCode> = {
  de: 'de-DE',
  en: 'en-GB',
};

export const DIRECTUS_ENVIRONMENT = new InjectionToken<DirectusEnvironment>('DIRECTUS_ENVIRONMENT');
export const FIND_BY_DIRECTUS_LOCALE = new InjectionToken<<T extends TranslatedField>(t: T) => t is T>(
  'DIRECTUS_LOCALE'
);
